<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="$parent.close()"></button></span>
        <div slot="content">
            <el-descriptions class="margin-top" :column="2" size="small" border>
                <el-descriptions-item>
                    <template slot="label">
                        대외모델
                    </template>
                    {{ form.model1 }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        관리모델
                    </template>
                    {{ form.model2 }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        생산일자
                    </template>
                    {{ form.prodDt }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        무상보증기간
                    </template>
                    {{ form.stDt }} ~ {{ form.endDt }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        회사명
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        Brand명
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        PANEL 방식
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        Pixel Pitch
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        시야각
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        명암비율
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        밝기
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        응답속도
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        수직주파수
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        수평주파수
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        권장해상도
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        최대해상도
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        영상신호
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        정격전압
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        소비전력(절전모드시)
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        무게
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        스피커
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        Bezel색상
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        특기사항
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        제조원
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        제품군
                    </template>
                    {{ `` }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        대표모델
                    </template>
                    {{ `` }}
                </el-descriptions-item>
            </el-descriptions>
        </div>
    </layout>
</template>

<script>
/**
 * * components
 */
 import Layout from '@/components/Slot/ModalSlot.vue';

 export default {
    
    components: {Layout},
    props: {
        title: {
            Type: String,
            required: false,
            default: `LCD사양정보`
        }
    },
    data() {
        return {
            form: {
                model1: 'S2200FBG',
                model2: 'L220DMW-5GSTK',
                prodDt: '2023-01-01',
                stDt: '2023-01-01',
                endDt: '2023-03-01',
            }
        }
    },
    computed() {
        
    }
 }
</script>